exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-positions-js": () => import("./../../../src/pages/positions.js" /* webpackChunkName: "component---src-pages-positions-js" */),
  "component---src-templates-stacked-page-js": () => import("./../../../src/templates/stacked-page.js" /* webpackChunkName: "component---src-templates-stacked-page-js" */)
}

